import api from "./api";

const paymentService = {
  getCreditCards: (jwttoken) =>
    api.get("/payments/credit", {
      headers: { Authorization: `Bearer ${jwttoken}` },
    }),
  deleteCreditCard: (jwttoken, id) =>
    api.delete(`/payments/credit/${id}`, {
      headers: { Authorization: `Bearer ${jwttoken}` },
    }),
  createWithNewCreditCard: (
    jwttoken,
    value,
    creditCard,
    creditCardHolderInfo
  ) =>
    api.post(
      "/payments/credit",
      { value, creditCard, creditCardHolderInfo },
      {
        headers: { Authorization: `Basic ${jwttoken}` },
      }
    ),
  createWithExistingCreditCard: (jwttoken, value, creditCardId) =>
    api.post(
      "/payments/credit",
      { value, credit_card_id: creditCardId },
      {
        headers: { Authorization: `Basic ${jwttoken}` },
      }
    ),
  createPix: (jwttoken, value) =>
    api.post(
      "/payments/pix",
      { value },
      {
        headers: { Authorization: `Basic ${jwttoken}` },
      }
    ),
  createBoleto: (jwttoken, value) =>
    api.post(
      "/payments/boleto",
      { value },
      {
        headers: { Authorization: `Basic ${jwttoken}` },
      }
    ),
  createTransfer: (jwttoken, value, bankAccountId) =>
    api.post(
      "/payments/transfer",
      { value, bank_account_id: bankAccountId },
      {
        headers: { Authorization: `Basic ${jwttoken}` },
      }
    ),
};

export default paymentService;
